<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "cooperative-deduction-wrapper"
};
</script>

<style>
</style>